import { Button, Divider } from "@mui/material"
import React from "react"
import { useTranslation } from "react-i18next"
import { useMediaQuery } from "react-responsive"
import InputTextField from "src/components/atom/InputTextField"
import { OutlinedButton } from "src/components/buttons/OutlinedButton"
import { Career } from "src/openapi"
import { Box, Checkbox } from "src/UILibrary"
import { CareerInputItems } from "../component/CareerInputItems"

type Prop = {
  abstract: string
  handleAbstract: any
  message: string
  handleMessage: any
  career: Career[]
  handleCareer: any
  agreeTerm: boolean
  handleAgreeTerm: any
  agreePolicy: boolean
  handleAgreePolicy: any
  abstractValidationMessage: string
  messageValidationMessage: string
  careerValidationMessage: string
  handlePrev: any
  handleNext: any
}

export const AdviserPRInformation = ({
  abstract,
  handleAbstract,
  message,
  handleMessage,
  career,
  handleCareer,
  agreeTerm,
  handleAgreeTerm,
  agreePolicy,
  handleAgreePolicy,
  abstractValidationMessage,
  messageValidationMessage,
  careerValidationMessage,
  handlePrev,
  handleNext,
}: Prop) => {
  const { t } = useTranslation("translation", { keyPrefix: "signup" })

  const isPC = useMediaQuery({ query: "(min-width: 720px)" })

  return (
    <Box maxWidth="md" sx={{ mx: "auto" }}>
      <InputTextField
        name={t("history")}
        placeholder={t("history_placeholder")}
        multiline
        required
        inputStyle={{
          width: isPC ? "690px" : "100%",
        }}
        text={abstract}
        handleText={handleAbstract}
        validationMessage={abstractValidationMessage}
        maxLength={400}
      />
      <InputTextField
        name={t("message")}
        placeholder={t("message_placeholder")}
        multiline
        required
        sx={{ mt: "40px" }}
        inputStyle={{
          width: isPC ? "690px" : "100%",
        }}
        text={message}
        handleText={handleMessage}
        validationMessage={messageValidationMessage}
        maxLength={400}
      />
      <CareerInputItems
        required
        sx={{ mt: "80px" }}
        career={career}
        handleCareer={handleCareer}
        validationMessage={careerValidationMessage}
      />
      <Divider sx={{ my: "80px" }}></Divider>
      <InputTextField
        name={t("term")}
        sx={{ mt: "40px" }}
        inputStyle={{ width: isPC ? "690px" : "100%", color: "gray" }}
        text={t("term_text")}
        required
        multiline
        readOnly
      />
      <Checkbox
        label={t("agree")}
        checked={agreeTerm}
        onChange={(event, checked) => handleAgreeTerm(checked)}
      />
      <InputTextField
        name={t("policy")}
        sx={{ mt: "40px" }}
        inputStyle={{ width: isPC ? "690px" : "100%", color: "gray" }}
        text={t("policy_text")}
        required
        multiline
        readOnly
      />
      <Checkbox
        label={t("agree")}
        checked={agreePolicy}
        onChange={(event, checked) => handleAgreePolicy(checked)}
      />
      {isPC ? (
        <Box display="flex">
          <OutlinedButton
            caption={t("back")}
            fontColor="primary.main"
            fontWeight="700"
            sx={{
              borderColor: "primary.main",
              minWidth: "240px",
              py: "16px",
              px: "88px",
              fontSize: "1rem",
              fontFamily: "Noto Sans JP !important",
              lineHeight: "1rem",
              fontWeight: 700,
              my: "80px",
              ml: "auto",
              mr: "40px",
              display: "flex",
              justifyContent: "center",
              borderRadius: 0,
            }}
            onClick={() => handlePrev()}
          />
          <Button
            variant="contained"
            sx={{
              minWidth: "240px",
              py: "16px",
              px: "88px",
              fontSize: "1rem",
              fontFamily: "Noto Sans JP !important",
              lineHeight: "1rem",
              fontWeight: 700,
              my: "80px",
              ml: 0,
              mr: "auto",
              display: "flex",
              justifyContent: "center",
              borderRadius: 0,
              ":hover": {
                bgcolor: "#2DA389",
              },
            }}
            onClick={() => handleNext()}
          >
            {t("register")}
          </Button>
        </Box>
      ) : (
        <Box display="flex" flexDirection="column">
          <Button
            variant="contained"
            sx={{
              width: "240px",
              py: "16px",
              px: "80px",
              fontSize: "1rem",
              fontFamily: "Noto Sans JP !important",
              lineHeight: "1rem",
              fontWeight: 700,
              mt: "80px",
              mx: "auto",
              display: "flex",
              justifyContent: "center",
              borderRadius: 0,
              ":hover": {
                bgcolor: "#2DA389",
              },
            }}
            onClick={() => handleNext()}
          >
            {t("register")}
          </Button>
          <OutlinedButton
            caption={t("back")}
            fontColor="primary.main"
            fontWeight="700"
            sx={{
              borderColor: "primary.main",
              width: "240px",
              py: "16px",
              px: "80px",
              fontSize: "1rem",
              fontFamily: "Noto Sans JP !important",
              lineHeight: "1rem",
              fontWeight: 700,
              mt: "20px",
              mb: "40px",
              mx: "auto",
              display: "flex",
              justifyContent: "center",
              borderRadius: 0,
            }}
            onClick={() => handlePrev()}
          />
        </Box>
      )}
    </Box>
  )
}
